<sirius-container>
    @if (tags.length) {
        <sirius-chips class="sir-tags" [chips]="tags" [ariaLabel]="'Tags'"></sirius-chips>
    }
    <div class="sir-date-author-links">
        <div class="sir-date-author">
            <strong
                ><time class="sir-date" [dateTime]="publishedAt">{{ publishedAt }}</time>
            </strong>
            <span class="sir-author">{{ authorName }}</span>
        </div>
        @if (socialMediaLinks.length) {
            <div class="sir-links-container">
                <strong class="sir-share-text">{{ 'page.share' | translate }}</strong>
                <div class="sir-links">
                    @for (soMeLink of socialMediaLinks; track $index) {
                        @if (soMeLink.icon) {
                            <a [siriusLink]="soMeLink.link" (linkSelect)="onClick(soMeLink)">
                                <sirius-icon [name]="soMeLink.icon"></sirius-icon>
                            </a>
                        }
                    }
                </div>
            </div>
        }
    </div>
</sirius-container>
